import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ExpertiseAreas = () => {
  const expertiseAreas = [
    {
      id:'niwjxuloe5cfnBVAIxPr',
      title: 'חדלות פרעון והוצאה לפועל',
      description: 'מומחים במחיקת חובות',
      path: '/topic/execution',
      icon: '⚖️'
    },
    {
      id:'vzOfLHY5Y0lGDXpQbnie',
      title: ' נזיקין ואזרחי ',
      description: 'טיפול מקצועי בתביעות נזיקין ואזרחי',
      path: '/topic/damages',
      icon: '🏛️'
    },
    {
      id:'Cq3auS1VsmtbG10Kw2ef',
      title: 'נדל"ן',
      description: 'ליווי עסקאות נדל"ן מורכבות',
      path: '/topic/realestate',
      icon: '🏠'
    }
  ];

  return (
    <div  id="expertise-areas" className="max-w-6xl mx-auto px-4 py-20">
      <h2 className="text-3xl font-bold text-center mb-16">תחומי התמחות</h2>
      
      {/* דסקטופ */}
      <div className="md:grid md:grid-cols-3 md:gap-12 hidden ">
        {expertiseAreas.map((area, index) => (
          <Link
            key={index}
            to={area.path}
            className="group relative flex justify-center"
          >
            <div className="absolute w-64 h-64 bg-blue-100 rounded-full blur-xl opacity-70 group-hover:opacity-100 transition-all duration-300"></div>
            <div className="
              w-64 h-64
              rounded-full
              bg-gradient-to-br from-white to-blue-50
              shadow-lg
              p-6
              flex flex-col items-center justify-center
              text-center
              relative
              overflow-hidden
              transform transition-all duration-300
              group-hover:scale-105
              group-hover:shadow-2xl
              border border-blue-100
            ">
              <div className="text-5xl mb-4">{area.icon}</div>
              <h3 className="text-xl font-bold mb-3">{area.title}</h3>
              <p className="text-gray-600 text-sm px-4">{area.description}</p>
              
              <div className="
                absolute bottom-0 left-0 right-0
                bg-gradient-to-t from-[#64748b] to-transparent
                text-white
                py-4
                transform translate-y-full
                group-hover:translate-y-0
                transition-transform duration-300
                flex items-center justify-center
                gap-2
              ">
                <span>קרא עוד</span>
                <ArrowLeft className="w-4 h-4" />
              </div>
            </div>
          </Link>
        ))}
      </div>

    {/* מובייל - גרסה משופרת */}
<div className="md:hidden flex justify-between gap-1"> {/* הקטנו את הgap */}
  {expertiseAreas.map((area, index) => (
    <Link
      key={index}
      to={area.path}
      className="group relative flex-1 flex justify-center max-w-[33%] active:scale-95 transition-transform"
    >
      <div className="absolute inset-0 bg-blue-100 rounded-full blur-lg opacity-70 group-hover:opacity-100 transition-all duration-300"></div>
      <div className="
        w-full aspect-square
        rounded-full
        bg-gradient-to-br from-white to-blue-50
        shadow-md
        p-2 {/* הקטנו את הpadding */}
        flex flex-col items-center justify-center
        text-center
        relative
        overflow-hidden
        transform transition-all duration-300
        group-hover:scale-105
        group-hover:shadow-xl
        border border-blue-100
        group-active:scale-95
      ">
        <div className="text-xl mb-1">{area.icon}</div> {/* הקטנו את גודל האייקון */}
        <h3 className="text-xs font-bold mb-0.5 line-clamp-2">{area.title}</h3> {/* הקטנו את הטקסט והוספנו line-clamp */}
        <p className="text-gray-600 text-[10px] leading-tight mb-4 line-clamp-2">{area.description}</p> {/* הקטנו את התיאור */}
        
        <div className="
          absolute bottom-0 left-0 right-0
          bg-gradient-to-t from-[#64748b] via-[#64748b] to-transparent
          text-white
          py-1
          flex items-center justify-center
          gap-1
          text-[10px]
          active:bg-blue-700
          touch-action-manipulation
          select-none
          cursor-pointer
        ">
          <span className="font-thin">קרא עוד</span>
          <ArrowLeft className="w-2 h-2 animate-bounce-x" />
        </div>
      </div>
    </Link>
  ))}
</div>
    </div>
  );
};

// הוספת אנימציה מותאמת לחץ
const style = document.createElement('style');
style.textContent = `
  @keyframes bounce-x {
    0%, 100% { transform: translateX(0); }
    50% { transform: translateX(-3px); }
  }
  .animate-bounce-x {
    animation: bounce-x 1s infinite;
  }
`;
document.head.appendChild(style);

export default ExpertiseAreas;